document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const section = select.closest('[data-product-section]');
      const price = section?.querySelector('[data-product-price]');
      const button = section?.querySelector('[data-add-to-cart]');
      const available = option?.dataset.available === 'true';

      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = !available;
        button.textContent = available ? 'Add to bag' : 'Sold out';
      }
    });
  });

  document.querySelectorAll('.mobile-menu nav a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });
});
